import clsx from 'clsx'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { useMediaQuery } from '@hotmart/space-lib/dist/hooks'
import { useUser } from 'src/hook/useUser'
import { ScreenSizes } from 'src/styles'
import {
  AuthorName,
  Avatar,
  Counter,
  Reaction,
  Text,
  Title,
  Wrapper
} from './feedCardSkeleton.styles'
import { FeedCardSkeletonProps } from './feedCardSkeleton.types'

const FeedCardSkeleton = ({ length = 1, className }: FeedCardSkeletonProps) => {
  const { theme } = useUser()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)

  return (
    <>
      {Array.from({ length }, (_, index) => (
        <Wrapper
          key={index}
          data-test="feed-card-skeleton"
          role="status"
          aria-busy="true"
          className={clsx(
            className,
            '_mb-5 _border _border-gray-200 _rounded-lg _position-relative',
            {
              '_bg-gray-100': theme === ThemeMode.DARK,
              '_bg-white': theme === ThemeMode.LIGHT
            }
          )}
        >
          <header className="_d-flex _align-items-center _pt-4 _px-4 _pb-3">
            <Avatar />

            <div className="_ml-3">
              <AuthorName className="_mb-2" />
              <Text />
            </div>
          </header>

          <div className="_p-4">
            <Title className="_mb-3" />
            <Text className="_mb-2" />
            <Text className="_mb-2" />
            <Text />
          </div>

          <footer
            className={clsx(
              '_d-flex _align-items-start _align-items-md-center _justify-content-between _flex-column-reverse _flex-md-row _border-top _border-gray-200',
              {
                '_p-4': !isMobile
              }
            )}
          >
            <div className={clsx('_d-flex _align-items-center', { '_p-4': isMobile })}>
              <Counter className="_mr-2" />
              <Counter />
            </div>

            <div
              className={clsx('_d-flex _align-items-center', {
                '_w-full _p-4 _border-bottom _border-gray-200': isMobile
              })}
            >
              <Reaction />
              <Reaction className="_ml-2" />
              <Reaction className="_ml-2" />
              <Reaction className="_ml-2" />
              <Reaction className="_ml-2" />
            </div>
          </footer>
        </Wrapper>
      ))}
    </>
  )
}

export default FeedCardSkeleton
